"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _ = require('underscore'); // ref: OverDrive.Thunder.Models.DataModels.GeneratedCollectionDetails


module.exports =
/*#__PURE__*/
function () {
  function GeneratedCollectionDetails() {
    _classCallCheck(this, GeneratedCollectionDetails);

    this.mediaType = '';
    this.language = '';
    this.publisherEntityId = null; // int

    this.maturityLevels = []; // string

    this.subjects = []; // string

    this.sortBy = '';
    this.maxItems = undefined; // int

    Object.assign.apply(Object, [this].concat(Array.prototype.slice.call(arguments)));
  } // Translates GeneratedCollectionDetails model to parameters that align with the MediaParameters model for executing a "search"


  _createClass(GeneratedCollectionDetails, [{
    key: "serializeForSearch",
    value: function serializeForSearch() {
      var model = _.extend({}, this); // language is an array in MediaParameters


      model.language = _(_.flatten([model.language])).reject(function (val) {
        return _.isEmpty(val);
      }); // maturityLevels is called maturityLevel

      model.maturityLevel = _(_.flatten([model.maturityLevels])).reject(function (val) {
        return _.isEmpty(val);
      });
      delete model.maturityLevels; // subjects is called subject

      model.subject = _(_.flatten([model.subjects])).reject(function (val) {
        return _.isEmpty(val);
      });
      delete model.subjects;
      return model;
    }
  }]);

  return GeneratedCollectionDetails;
}();